<!-- loading spinner -->
<div *ngIf="isLoading" class="text-center m-3">
  <app-spinner size="l" dark="true"></app-spinner>
  <p>{{'LOADING'|translate}}</p>
</div>

<ng-container *ngIf="!isLoading">

  <div *ngIf="reservationInfo && reservationInfo.header" class="alert alert-warning" role="alert">
    <strong>{{reservationInfo.header}}</strong><br />
    <p *ngIf="reservationInfo.primary">{{reservationInfo.primary}}</p>
    <p *ngIf="reservationInfo.secondary">{{reservationInfo.secondary}}</p>
  </div>

  <div *ngIf="reservationConflictReport.length > 0 && isNewReservation && !hasMultipleDates" class="alert alert-danger"
    role="alert">
    <ng-container *ngIf="reservationConflictReport.length > 0 && singleConflict !== undefined">

      <p>{{'RESERVATION_NOT_POSSIBLE_NOTICE_SINGLE' | translate: { timeFrom: singleConflict.timeFrom,
        timeTo: singleConflict.timeTo,
        resourceLabel: resourceLabelWithArticle
        } }}
      </p>
      <span class="d-block">{{'RESERVATION_NOT_POSSIBLE_REASON' | translate }}:</span>
    </ng-container>

    <ng-container *ngIf="reservationConflictReport.length > 0 && singleConflict !== undefined">

      <span class="d-block" *ngFor="let ts of singleConflict.conflictingTimeSpans"> -
        {{'TIMESPAN_UNTIL'| translate : {startTime: ts.startTime, endTime: ts.endTime } }}</span>
    </ng-container>
  </div>

  <div *ngIf="reservationConflictReport.length > 1 && hasMultipleDates" class="alert alert-danger" role="alert">
    <p class="m-0">{{'RESERVATION_NOT_POSSIBLE_NOTICE_MULTIPLE' | translate: { resourceLabel: resourceLabelWithArticle }
      }}
    </p>
  </div>

  <h4>{{'YOUR_EVENT'|translate}}</h4>

  <form [formGroup]="form.formGroup">
    <div class="form-row">
      <!-- Raum -->
      <app-form-group formControlName="roomNumber" id="inputRoomNumber" name="roomNumber" class="col" type="text"
        text="{{numberControlText|translate}}"></app-form-group>

      <!-- Anzahl Personen -->
      <app-form-group *ngIf="displaySeatsControl" formControlName="seats" id="inputSeats" name="seats" class="col-6"
        type="text" text="{{'NUMBER_PERSONS'|translate}}"></app-form-group>
    </div>

    <!-- date and time -->
    <ng-container *ngIf="isNewReservation && !hasMultipleDates">
      <div formArrayName="dates">
        <app-create-reservation-date [type]="type" [formGroupName]="0" [formGroup]="dates.controls[0]"
          [idRessource]="params.idRessource" [isNewReservation]="isNewReservation" hideButtons="true"
          (reservationConflict)="promptConflictingTimesNotice($event)" [resourceOccupancies]="resourceOccupancies"
          (conflictResolved)="dismissConflictingTimesNotice($event)" [supressErrorMessageNotice]="true">
        </app-create-reservation-date>
      </div>
    </ng-container>

    <div class="form-row">
      <!-- Titel des Anlasses -->
      <app-form-group formControlName="title" id="inputTitle" name="title" class="col-12" type="text" required="true"
        text="{{'EVENT_TITLE'|translate}}"></app-form-group>

      <!-- Weitere Details -->
      <app-form-group formControlName="furtherDetails" id="textareaFurtherDetails" name="furtherDetails" class="col-12"
        type="textarea" text="{{'FURTHER_DETAILS'|translate}}" [rows]="furtherDetailsRows"></app-form-group>

    </div>

    <!-- Buttons, 1st row -->
    <div *ngIf="displayStornoButton || display1StSaveButton" class="row mt-4">

      <div *ngIf="displayStornoButton" class="col">
        <app-button text="{{'BTN_STORNO'|translate}}" (buttonClick)="onCancelReservationClick()" btnStyle="secondary">
        </app-button>
      </div>

      <div *ngIf="display1StSaveButton" class="col text-right">
        <app-button text="{{'BTN_SAVE'|translate}}" [disabled]="!enableSaveButton"
          (buttonClick)="onSaveReservationClick()">
        </app-button>
      </div>

    </div>

    <!-- Termine -->
    <ng-container *ngIf="displayDates">
      <hr>
      <h4>{{'DATES'|translate}}</h4>
      <div formArrayName="dates">
        <ng-container *ngFor="let date of dates.controls; let i=index">
          <app-create-reservation-date [type]="type" *ngIf="date.getRawValue().id" [isNewReservation]="isNewReservation"
            [index]="i" [formGroupName]="i" [formGroup]="date" [idRessource]="params.idRessource" [hideLabels]="i!=0"
            (save)="onSaveDateClick($event)" (delete)="onDeleteDateClick($event)" (restore)="onRestoreDateClick($event)"
            (reservationConflict)="promptConflictingTimesNotice($event)"
            (conflictResolved)="dismissConflictingTimesNotice($event)"
            [dataLoader]="prepLoadOccupanciesData(params.idRessource)">
          </app-create-reservation-date>
        </ng-container>
      </div>
    </ng-container>

    <!-- Neue Termine -->
    <ng-container *ngIf="displayNewDates">
      <hr>
      <h4>{{'NEW_DATES'|translate}}</h4>
      <div formArrayName="dates">
        <ng-container *ngFor="let date of dates.controls; let i=index">
          <app-create-reservation-date [type]="type" *ngIf="!date.getRawValue().id"
            [isNewReservation]="isNewReservation" [index]="i" [formGroupName]="i" [formGroup]="date"
            [idRessource]="params.idRessource" [hideLabels]="i!=0" (save)="onSaveDateClick($event)"
            (delete)="onDeleteDateClick($event)" (restore)="onRestoreDateClick($event)"
            (reservationConflict)="promptConflictingTimesNotice($event)"
            (conflictResolved)="dismissConflictingTimesNotice($event)"
            (dateNotReservable)="onRegisterUnavailableDateChoice($event)"
            [dataLoader]="prepLoadOccupanciesData(params.idRessource)">
          </app-create-reservation-date>
        </ng-container>
      </div>
    </ng-container>

    <!-- Fehlerhafte ignorieren -->
    <div *ngIf="hasMultipleNewDates && hasUnavailableDateChosen" class="custom-control custom-checkbox my-3">
      <input type="checkbox" class="custom-control-input" id="checkIgnoreErroneousLessons"
        formControlName="ignoreErroneousLessons">
      <label class="custom-control-label"
        for="checkIgnoreErroneousLessons">{{'IGNORE_DEFECTIVE_EVENTS'|translate}}</label>
    </div>

    <!-- Intervall Creator -->
    <app-create-reservation-interval *ngIf="displayFurtherDatesControl && allowSerialDateReservations"
      [startDate]="lastDate" (datesGenerated)="onFurtherDatesGenerated($event)"></app-create-reservation-interval>

    <!-- Buttons, 3rd row -->
    <div class="row mt-4">

      <div *ngIf="!displayFurtherDatesControl && allowSerialDateReservations" class="col">
        <app-button text="{{'FURTHER_EVENTS'|translate}}" [disabled]="!enableFurtherDateButton"
          (buttonClick)="onFurtherDateClick()" btnStyle="secondary"></app-button>
      </div>

      <div *ngIf="display2NdSaveButton" class="col text-right">
        <app-button text="{{'BTN_SAVE'|translate}}" [disabled]="!enableSaveButton"
          (buttonClick)="onSaveReservationClick()">
        </app-button>
      </div>

      <div *ngIf="displaySaveNewDatesButton" class="col text-right">
        <app-button text="{{'BTN_SAVE_NEW_DATES'|translate}}" [disabled]="!enableSaveNewDatesButton"
          (buttonClick)="onSaveDateBatchClick()"></app-button>
      </div>

    </div>

  </form>

</ng-container>

<!-- FIXME: -->
<!-- <pre>{{form.formGroup.value|json}}</pre> -->

<!-- bookmark delete dialog -->
<app-modal-dialog #confirmDeleteDialog title="{{confirmDeleteActionTitle}}" [body]="modalBodyDelete"
  [showPositive]="false" [showNegative]="true" [negativeButton]="'BTN_YES'|translate"
  [cancelButton]="'BTN_NO'|translate" (negative)="onModalClickDelete()"></app-modal-dialog>
<ng-template #modalBodyDelete>
  <p>{{confirmDeleteInfo.text}}</p>
</ng-template>